/**
 * Draft preview gate, shared by BlogPost and SeriesPage (#363, #539).
 *
 * Production hosts never serve unpublished posts. Drafts stay readable off
 * production so beta remains a review surface. `DEV` covers `npm run dev`; the
 * hostname check covers beta.educ4te.com and *.pages.dev preview builds, which
 * are production builds and so not caught by `DEV`.
 */
export const PRODUCTION_HOSTS = ['educ4te.com', 'www.educ4te.com'];

export const canPreviewDrafts = () => {
  if (import.meta.env.DEV) return true;
  if (typeof window === 'undefined') return false;
  if (window.__EDUC4TE_PRERENDER_PRODUCTION__ === true) return false;
  return !PRODUCTION_HOSTS.includes(window.location.hostname);
};

// A missing post is never visible, including on beta preview hosts.
export const isVisible = (post) => Boolean(post) && (post.status === 'published' || canPreviewDrafts());

export const isSeriesVisible = (series) => {
  if (canPreviewDrafts()) return true;
  return !series?.publishDate || series.publishDate <= new Date().toISOString().slice(0, 10);
};
